import { Fragment, type ReactNode, useEffect } from 'react';
import { useCorePermissions } from '@/utils/apiRestCalls/core-permissions.api';
import { PermissionKeyEnum } from '../permission.types';
import { useCorePermissionsStore } from '../permissions.store';
import { savePermissionsToStorage } from '../permissions.storage';

type Props = {
  children: ReactNode;
};

export function CoreWrapper({ children }: Props) {
  const setCorePermissions = useCorePermissionsStore((state) => state.setCorePermissions);
  const { data: corePermissionsResponse, isFetched } = useCorePermissions();

  useEffect(() => {
    if (isFetched) {
      const corePermissions = corePermissionsResponse?.corePermissionStatus || [];
      setCorePermissions(corePermissions);
      savePermissionsToStorage(PermissionKeyEnum.Core, corePermissions);
    }
  }, [isFetched]);

  return <Fragment>{children}</Fragment>;
}
